import { PixiModelSettings } from "./types";

export const models: Record<string, PixiModelSettings> = {
   
}